/* Publish by EComposer at 2026-09-26 09:57:40*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tsu4hqh541"]=  window.__ectimmers["ecom-tsu4hqh541"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-tsu4hqh541').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsu4hqh541', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0o56mez5johi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0o56mez5johi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z26kuprl2ii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z26kuprl2ii', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89673qg5a8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89673qg5a8a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d767rmxr4ba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d767rmxr4ba', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gntgrtjo5c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gntgrtjo5c', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-83evi6k7oxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-83evi6k7oxc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93vkhdbjtwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93vkhdbjtwl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7q2g3dkt33x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7q2g3dkt33x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esiy6ivqnr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esiy6ivqnr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djymnnnbnt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djymnnnbnt8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ot0ao4ur2eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ot0ao4ur2eh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9s284xsa5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9s284xsa5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpetttrg7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpetttrg7q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tw4z8f9fif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tw4z8f9fif', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tegsxgd2nf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tegsxgd2nf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9k1xywnbq3u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9k1xywnbq3u', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xon8ytie3an').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xon8ytie3an', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im8kb0rmc8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im8kb0rmc8f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7znqk335ipw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7znqk335ipw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28eqh9pi14n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28eqh9pi14n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ir2ytah45kj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ir2ytah45kj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fb0jadeyakb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fb0jadeyakb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4phy5clg1fc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4phy5clg1fc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xetslclas9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xetslclas9h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnwjjt1gxe8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnwjjt1gxe8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbjqe1mzu8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbjqe1mzu8f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lev0jypwdv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lev0jypwdv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itmujuuf3ab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itmujuuf3ab', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iovzaj16858').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iovzaj16858', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5q76zealtp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5q76zealtp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xf82ukqa3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xf82ukqa3s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5fsi5evdivh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5fsi5evdivh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d47ppkkv9q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d47ppkkv9q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmlc3wkrh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmlc3wkrh6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zsfnpk4k5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zsfnpk4k5o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nyotvu0qtse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nyotvu0qtse', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51r0qnocscr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51r0qnocscr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-84wctxoylb3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-84wctxoylb3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            